import React, { useContext, useEffect, useState } from "react";
import { boolean } from "zod";
export type MainMenuContent = {
    openMenu: boolean,
    activeItem: MenuItems | null,
    handleSelection: (value: MenuItems | null) => void
    toggleMenu: () => void
}

const MainMenuContent = React.createContext<MainMenuContent>({
    openMenu: false,
    toggleMenu: () => { return },
    activeItem: null,
    handleSelection: () => { return }
})

MainMenuContent.displayName = "MainMenuContext"
const useMainMenuContext = () => useContext(MainMenuContent)
interface IProps {
    children: React.ReactNode
}
type MenuItems = "CHILDREN" | "STAFF" | "INSIGHTS" | "COMPANY"
const MainMenuContextProvider = (props: IProps) => {
    const { children } = props;
    const [openMenu, setOpenMenu] = useState(false)
    const [activeItem, setActiveItem] = useState<MenuItems | null>(null);
    const toggleMenu = () => {
        setOpenMenu(!openMenu)
        return;
    }
    const handleSelection = (value: MenuItems | null) => {
        setActiveItem(value)
    }

    return (
        <MainMenuContent.Provider
            value={{
                openMenu, toggleMenu,
                activeItem, handleSelection
            }}>
            {children}
        </MainMenuContent.Provider>
    )
}

export { useMainMenuContext, MainMenuContextProvider }